import config from '@/config'
import Invitations, { IInvitations } from '@/models/Invitations'
import { useGlobalStore } from '@/store/app'
import BaseService from './BaseService'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

const http = requests(config?.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('groupId')
class InvitationsServiceCls extends BaseService<Invitations> {
  constructor() {
    super(null as any)
  }

  model() {
    return Invitations
  }

  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/${appStore.locationId}/groups/${appStore.groupId}/invitations`
  }

  async create(data: IInvitations): Promise<any> {
    const response = await http.post(`${this.endpoint}`, data)
    return response?.data
  }

  async acceptInvitation(invitationId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${invitationId}/accept`,
      {}
    )
    return response?.data
  }

  async findById(id: string, params?: any): Promise<any> {
    const response = await http.get(`${this.endpoint}/${id}`, { params })
    return response.data
  }

  async delete(id: string): Promise<any> {
    const response = await http.delete(`${this.endpoint}/${id}`)
    return response.data
  }
}

// Export singleton instance
export const InvitationsService = new InvitationsServiceCls()

// Export type for dependency injection
export type IInvitationsService = InvitationsServiceCls

// Export commonly used methods directly
export const {
  create,
  findById,
  delete: deleteInvitation,
  acceptInvitation,
} = InvitationsService
